import { Avatar, Icon, Typography } from "@/components/atoms";
import { getAssetUrl } from "@/utils";
import { useExternalSupplierProfileProfileContext } from "../../context";

export const ExternalSupplierHeader = () => {
  const { externalSupplier } = useExternalSupplierProfileProfileContext();
  const { name, rating, avatar } = externalSupplier;

  const renderAvatar = () => {
    const src = getAssetUrl(avatar || "", { height: 128, width: 128, fit: "cover" });
    return <Avatar size="xl" src={src} alt={name} />;
  };

  const renderRating = () => {
    const { jobsCompleted, rating: externalSupplierRating } = rating;
    if (jobsCompleted) {
      return (
        <div className="flex flex-row items-center gap-1.5">
          {(externalSupplierRating || externalSupplierRating === 0) && (
            <div className="flex flex-row items-center gap-x-2">
              <Icon name="Star1" className="fill-warning text-warning" />
              <Typography variant="title">{externalSupplierRating}</Typography>
            </div>
          )}
          <Typography variant="action" className="text-neutral-dark-gray">
            {`(${jobsCompleted} ${jobsCompleted === 1 ? "Job" : "Jobs"})`}
          </Typography>
        </div>
      );
    }
  };

  return (
    <div className="flex flex-row items-center gap-6">
      {renderAvatar()}
      <div className="flex w-full flex-row">
        <div className="flex flex-1 flex-col gap-1">
          <Typography variant="h3" className="flex items-center gap-2">
            {name}
          </Typography>
          {renderRating()}
        </div>
      </div>
    </div>
  );
};
